// extracted by mini-css-extract-plugin
export var actions = "_10-0";
export var actionsContainer = "_10-7";
export var border = "_10-1";
export var childFullHeight = "_10-g";
export var collapse = "_10-2";
export var content = "_10-b";
export var contentChild = "_10-f";
export var fullscreen = "_10-d";
export var hasLeftRadius = "_10-l";
export var headerContainer = "_10-3";
export var headerRow = "_10-5";
export var hidePadding = "_10-c";
export var navCollapsedGap = "_10-m";
export var noScrollX = "_10-n";
export var noScrollY = "_10-o";
export var noTopPadding = "_10-j";
export var optOutTopPadding = "_10-e";
export var pageMain = "_10-k";
export var pageOuter = "_10-h";
export var pagePadding = "_10-8";
export var pageScroll = "_10-9";
export var profile = "_10-p";
export var profileContainer = "_10-q";
export var profileImage = "_10-r";
export var profileMain = "_10-s";
export var profileSubtitle = "_10-u";
export var profileTitle = "_10-t";
export var settingsSurface = "_10-a";
export var showLeftPadding = "_10-i";
export var tabsPortalSlot = "_10-6";
export var tabsWrapper = "_10-4";
export var title = "_10-v";